import { GlobalCustomerSelect } from "../customer/global-customer-select";
import { computedFrom } from "aurelia-framework";

export class GlobalScopeSelect {
	static scopeItemName = "scope";
	itemName = GlobalScopeSelect.scopeItemName;
	parentItemName = GlobalCustomerSelect.customerItemName;
}
